module.exports = __webpack_public_path__ + "img/sunlong-1.f15108ad.png";